import { updateUserProfile as apiUpdateUserProfile } from './authService';

// Export the updateUserProfile function
export const updateUserProfile = async (profileData) => {
  try {
    const result = await apiUpdateUserProfile(profileData);
    
    // Update local storage user data with new profile information
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      if (userData) {
        const updatedUserData = { ...userData, ...profileData };
        localStorage.setItem('user', JSON.stringify(updatedUserData));
      }
    } catch (e) {
      console.error('Error updating user data in local storage:', e);
    }
    
    return result;
  } catch (error) {
    console.error('Failed to update user profile:', error);
    throw error;
  }
};

export default {
  updateUserProfile
}; 